(function () {
  document.documentElement.classList.add('utm-visibility-pending');

  function normalize(value) {
    return String(value || '').trim();
  }

  function normalizeLower(value) {
    return normalize(value).toLowerCase();
  }

  function getCurrentTrackingValues() {
    var params = new URLSearchParams(window.location.search);
    var values = {};

    params.forEach(function (value, key) {
      if (key.indexOf('utm_') === 0 || key === 'gclid' || key === 'fbclid') {
        values[key] = value;
      }
    });

    return values;
  }

  function storeTrackingValues(values, shouldStore) {
    if (!shouldStore) return;

    try {
      Object.keys(values).forEach(function (key) {
        sessionStorage.setItem('utm_visibility_' + key, values[key]);
      });
    } catch (error) {
      // sessionStorage can be unavailable in private browsing.
    }
  }

  function getStoredTrackingValue(paramName) {
    try {
      return sessionStorage.getItem('utm_visibility_' + paramName);
    } catch (error) {
      return null;
    }
  }

  function getEffectiveParamValue(paramName, currentValues) {
    if (!paramName) return '';

    if (Object.prototype.hasOwnProperty.call(currentValues, paramName)) {
      return currentValues[paramName];
    }

    return getStoredTrackingValue(paramName) || '';
  }

  function isSingleMatch(currentValue, targetValue, matchType) {
    currentValue = normalizeLower(currentValue);
    targetValue = normalizeLower(targetValue);

    if (!targetValue) return null;

    switch (matchType) {
      case 'contains':
        return currentValue.indexOf(targetValue) !== -1;
      case 'starts_with':
        return currentValue.indexOf(targetValue) === 0;
      case 'ends_with':
        return currentValue.slice(-targetValue.length) === targetValue;
      case 'equals':
      default:
        return currentValue === targetValue;
    }
  }

  function isCompositeUtmMatch(config) {
    var checks = [];

    if (config.sourceValue) {
      checks.push(isSingleMatch(config.currentSource, config.sourceValue, config.matchType));
    }

    if (config.campaignValue) {
      checks.push(isSingleMatch(config.currentCampaign, config.campaignValue, config.matchType));
    }

    if (config.termValue) {
      checks.push(isSingleMatch(config.currentTerm, config.termValue, config.matchType));
    }

    if (checks.length === 0) return false;

    return checks.every(function (result) {
      return result === true;
    });
  }

  function getSectionConfig(section, currentValues) {
    var enabled = section.getAttribute('data-utm-enabled') === 'true';
    var mode = section.getAttribute('data-utm-mode') || 'show_when_matched';
    var group = normalize(section.getAttribute('data-utm-group'));
    var sourceValue = normalize(section.getAttribute('data-utm-source-value'));
    var campaignValue = normalize(section.getAttribute('data-utm-campaign-value'));
    var termValue = normalize(section.getAttribute('data-utm-term-value'));
    var matchType = section.getAttribute('data-utm-match-type') || 'equals';
    var priority = parseInt(section.getAttribute('data-utm-priority') || '10', 10);
    var rememberSession = section.getAttribute('data-utm-remember-session') !== 'false';

    var config = {
      element: section,
      enabled: enabled,
      mode: mode,
      group: group,
      sourceValue: sourceValue,
      campaignValue: campaignValue,
      termValue: termValue,
      matchType: matchType,
      priority: isNaN(priority) ? 10 : priority,
      rememberSession: rememberSession,
      currentSource: getEffectiveParamValue('utm_source', currentValues),
      currentCampaign: getEffectiveParamValue('utm_campaign', currentValues),
      currentTerm: getEffectiveParamValue('utm_term', currentValues),
      matched: false
    };

    config.matched = isCompositeUtmMatch(config);

    return config;
  }

  function setHidden(section, hidden) {
    section.setAttribute('data-utm-hidden', hidden ? 'true' : 'false');
  }

  function applyVisibility() {
    var currentValues = getCurrentTrackingValues();
    var allSections = Array.prototype.slice.call(
      document.querySelectorAll('.utm-visibility-section')
    );

    var configs = allSections.map(function (section) {
      return getSectionConfig(section, currentValues);
    });

    var shouldStore = configs.some(function (config) {
      return config.enabled && config.rememberSession;
    });

    storeTrackingValues(currentValues, shouldStore);

    configs.forEach(function (config) {
      if (!config.enabled) {
        setHidden(config.element, false);
      }
    });

    var enabledConfigs = configs.filter(function (config) {
      return config.enabled;
    });

    var groupedConfigs = {};
    var ungroupedConfigs = [];

    enabledConfigs.forEach(function (config) {
      if (config.group) {
        if (!groupedConfigs[config.group]) {
          groupedConfigs[config.group] = [];
        }
        groupedConfigs[config.group].push(config);
      } else {
        ungroupedConfigs.push(config);
      }
    });

    ungroupedConfigs.forEach(function (config) {
      if (config.mode === 'hide_when_matched') {
        setHidden(config.element, config.matched);
      } else if (config.mode === 'show_when_matched') {
        setHidden(config.element, !config.matched);
      } else if (config.mode === 'fallback') {
        setHidden(config.element, false);
      }
    });

    Object.keys(groupedConfigs).forEach(function (groupName) {
      var group = groupedConfigs[groupName];
      var matchedShowSections = group
        .filter(function (config) {
          return config.mode === 'show_when_matched' && config.matched;
        })
        .sort(function (a, b) {
          return b.priority - a.priority;
        });
      var fallbackSections = group
        .filter(function (config) {
          return config.mode === 'fallback';
        })
        .sort(function (a, b) {
          return b.priority - a.priority;
        });
      var winningSection = null;

      if (matchedShowSections.length > 0) {
        winningSection = matchedShowSections[0];
      } else if (fallbackSections.length > 0) {
        winningSection = fallbackSections[0];
      }

      group.forEach(function (config) {
        if (config.mode === 'hide_when_matched') {
          setHidden(config.element, config.matched);
          return;
        }

        if (winningSection) {
          setHidden(config.element, config.element !== winningSection.element);
        } else {
          setHidden(config.element, true);
        }
      });
    });

    document.documentElement.classList.remove('utm-visibility-pending');
    document.documentElement.classList.add('utm-visibility-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyVisibility);
  } else {
    applyVisibility();
  }

  document.addEventListener('shopify:section:load', applyVisibility);
  document.addEventListener('shopify:section:select', applyVisibility);
})();
